// @flow

import React from 'react';
import colors from '../../../../../assets/values/colors';
import moment from 'moment-timezone';

// header

type Props = {
    newsItem: { [key: string]: any }
};

const NewsItem = (props: Props) => {
    let statusColor = colors.black;

    switch (props.newsItem.player_status) {
        case 'Active':
            statusColor = colors.green;
            break;
        case 'Out':
        case 'Out for Season':
        case 'Injured':
        case 'Doubtful':
        case 'Inactive':
        case 'Suspended':
            statusColor = colors.red;
            break;
        case 'Probable':
        case 'Questionable':
        default:
            statusColor = colors.cautionBlue;
            break;
    }

    let status = props.newsItem.player_status;
    if (props.newsItem.injury) {
        status += ' (' + props.newsItem.injury + ')';
    }
    const display = (
        <div key={props.newsItem.id} className={'news-blurb'}>
            <div className={'news-header'}>
                <div className={'news-status'}>
                    <i className={'fas fa-medkit'} style={{ color: statusColor }} /> &nbsp;
                    {status}
                </div>
                <div className={'news-date'}>{moment(props.newsItem.modified_date).format('MM/DD/YY h:mm A')}</div>
            </div>
            <div className={'bold'} style={{ padding: '10px 0 5px 0' }}>
                {props.newsItem.title}
            </div>
            <div style={{ paddingBottom: 10 }}>{props.newsItem.news}</div>
        </div>
    );

    return display;
};

export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/News/NewsItem/NewsItem.js